module.exports = __webpack_public_path__ + "static/media/BlackPanther.4a8840e6.png";